import { memo } from 'react';
import {
    compose,
    mapProps,
    setDisplayName
} from 'recompose';
import { usePortletConfig } from 'js/components/system/Portlet';
import { NgpGame, withCategory as withCategoryCore, GameWithJackpot } from 'js/components/main/Games/Game';

export const withCategory = compose(withCategoryCore, mapProps((props) => {
    const { showFavorites, isLoggedIn, isDesktop } = props;
    const { launchWithOneClick } = usePortletConfig();

    return {
        ...props,
        isHoverEnabled: isDesktop,
        showRecentlyPlayedIcon: false,
        showFavoriteIcon: showFavorites && isLoggedIn,
        showGameInfo: !isDesktop && !launchWithOneClick
    };
}));

export { NgpGame, GameWithJackpot };

export default compose(
    memo,
    setDisplayName('NgpGameWithCategory'),
    withCategory
)(NgpGame);
